import React, { useContext, useEffect, useState } from 'react'
import VideoSDK from 'components/VideoSKD'
import { Button } from '@mui/material'
import { Roles } from 'utils/enums'
import { IndentifiedTranslatorContext } from 'context/IdentifiedTranslatorContext'
import { useAuth } from 'context/AuthContext'
import { TranslatorDataContext } from 'context/TranslatorContext'
import useQuery from 'hooks/useQuery'
import { useNavigate } from 'react-router-dom'

const TranslatorDashboard = () => {
  const navigate = useNavigate()
  const { availableRoom, setAvailableRoom } = useContext(TranslatorDataContext)
  const { translator } = useContext(IndentifiedTranslatorContext)
  const { makeRequest: finishCall } = useQuery({
    isControlled: true,
    hideGlobalLoading: true,
  })

  const [roomId, setRoomId] = useState(null)
  const [disabled, setDisabled] = useState(true)
  const [finishingCall, setFinishingCall] = useState(false)

  useEffect(() => {
    if (!availableRoom) setRoomId(null)
  }, [availableRoom])

  useEffect(() => {
    setTimeout(() => setDisabled(false), 10_000)
  }, [])

  const finishCallHandler = async () => {
    if (!availableRoom?.callId || finishingCall) return
    setFinishingCall(true)
    try {
      const { error } = await finishCall({
        endpoint: `/translators/finishCall/${availableRoom.callId}`,
      })
      if (error) return
      setAvailableRoom(null)
      navigate('/translators')
    } finally {
      setFinishingCall(false)
    }
  }

  if (availableRoom?.roomId) {
    return roomId ? (
      <div className='w-full h-[100vh] relative z-20 mt-[-9vh]'>
        <VideoSDK
          token={availableRoom.token}
          redirectOnLeave={availableRoom.redirectOnLeave}
          meetingId={roomId}
          participantName={`${translator.firstName} ${translator.lastName}`}
          roleObject={Roles.Translator}
          participantCanLeave={false}
        />
        <Button
          className='fixed top-0 right-0 m-[12px] z-30'
          color='error'
          disabled={finishingCall}
          onClick={finishCallHandler}
          variant='contained'
        >
          {finishingCall ? 'Finalizando...' : 'Finalizar llamada'}
        </Button>
        {!availableRoom.free && (
          <CopyLinkButton availableRoom={availableRoom} />
        )}
      </div>
    ) : (
      <div className='flex justify-center mt-[5vh]'>
        <Button
          onClick={() => setRoomId(availableRoom.roomId)}
          disabled={disabled}
        >
          {disabled ? 'Cargando...' : 'Iniciar Videollamada'}
        </Button>
        {!availableRoom.free && (
          <CopyLinkButton availableRoom={availableRoom} />
        )}
      </div>
    )
  }

  return (
    <div className='flex justify-center mt-[5vh]'>
      <h1 className='m-[5vh] text-center'>Espere a sus llamados...</h1>
    </div>
  )
}

export const CopyLinkButton = ({ availableRoom }) => {
  const { origin } = window.location
  const { user } = useAuth()
  const [copyLinkButtonPressed, setCopyLinkButtonPressed] = useState(false)

  useEffect(() => {
    if (copyLinkButtonPressed) {
      setTimeout(() => setCopyLinkButtonPressed(false), 5000)
    }
  }, [copyLinkButtonPressed])

  return (
    <div className='fixed top-0 left-0 m-[12px] z-20'>
      <Button
        onClick={() => {
          navigator.clipboard.writeText(
            `${origin}/joinRequest?roomId=${availableRoom.roomId}&mediatorId=${user?.mediatorId}`,
          )
          setCopyLinkButtonPressed(true)
        }}
        disabled={copyLinkButtonPressed}
        style={
          copyLinkButtonPressed ? { color: 'green', background: '#ccc' } : {}
        }
      >
        {copyLinkButtonPressed ? 'Link copiado!' : 'Obtener Link'}
      </Button>
    </div>
  )
}

export default TranslatorDashboard
